function getView() {
  let DictCtxView = {
    model: "melhous.request_type",
    form_action: ["edit", "add", "save"],
    table_action: ["edit", "add", "delete"],
    activeSearch: false,
    target: "melhous",
    autoSave: true,
    domain: [],
    fields: {
      name: { type: "char", required: true },
      scope: {
        type: "selection",
        options: [
          { id: "table", name: "table" },
          { id: "room", name: "room" },
          { id: "both", name: "both" },
        ],
        translate: true,
        required: true,
      },
      active: { type: "boolean" },
      sequence: { type: "integer" },
    },
    list: [{ name: "name" }, { name: "scope" }, { name: "active" }],
    form: [
      { name: "name" },
      { name: "scope" },
      { name: "sequence" },
      { name: "active" },
    ],
  };

  return DictCtxView;
}

export default { ctxView: getView };
